export enum SessionStateEnum {
  Init = 'INIT',
  Logged = 'LOGGED',
  NotLogged = 'NOT_LOGGED',
}
